
export default {
  inheritAttrs: false,

  props: {
    notLazy: { type: Boolean, default: false },
    isClientOnly: { type: Boolean, default: false },
  },
}
